/* eslint no-unused-vars: off */
// External library
import Swiper from 'swiper/bundle'

// Component
export default () => {
    const swiperAwards = new Swiper('.awards-grid-swiper', {
        keyboard: {
            enabled: true
        },
        speed: 1000,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
        grid: {
            rows: 2,
            fill: 'row'
        },
        breakpoints: {
            992: {
                slidesPerView: 'auto',
                slidesPerGroup: 4,
                grid: {
                    rows: 1
                }
            },
            1200: {
                slidesPerView: 'auto',
                slidesPerGroup: 5,
                grid: {
                    rows: 1
                }
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    })

    const swiperCards = new Swiper(
        '[data-product-cards], [data-event-cards]', {
            keyboard: {
                enabled: true
            },
            slidesPerView: 'auto',
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        })

    let swiperSliders = new Swiper('[data-slider-cards]', {
        keyboard: {
            enabled: true
        },
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        autoplay: {
            pauseOnMouseEnter: true,
            disableOnInteraction: false
        }
    })

    if (!Array.isArray(swiperSliders))
        swiperSliders = [swiperSliders]

    swiperSliders
        .forEach((swiper) => swiper
            .on('slideChange', (swipe) => swipe.slides
                .forEach((s, i) => s
                    .setAttribute('aria-hidden', i !== swipe.activeIndex))))
}
